import ItemRow from './ItemRow'

export default class Item extends ItemRow {
  checklists: []

  constructor(item, locale) {
    super(item, locale)

    this.checklists = item.checklists.map((checklist) => {
      return {
        title: this.translateField(checklist._title, locale),
        fieldName: checklist.name,
        value: JSON.parse(checklist.value)
      }
    })
  }
}
